import React from 'react';
import { Box, VStack, HStack, Text, Heading } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';

const DesktopSidePanel: React.FC = () => {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';

  const features = [
    { icon: '✓', text: 'Works offline — no internet required' },
    { icon: '✓', text: 'No account, no sign-up, no tracking' },
    { icon: '✓', text: 'Multi-profile support' },
    { icon: '✓', text: 'Photo capture of your parking spot' },
    { icon: '✓', text: 'Free forever' },
  ];

  return (
    <VStack
      align="start"
      spacing={8}
      maxW="460px"
      w="100%"
      py={10}
    >
      {/* Brand */}
      <VStack align="start" spacing={3}>
        <Heading
          as="h1"
          fontSize="38px"
          fontWeight="900"
          color="white"
          letterSpacing="-0.03em"
          lineHeight="1"
          whiteSpace="nowrap"
          textShadow="0 2px 20px rgba(0,0,0,0.9)"
        >
          MyCarParkedWhere
        </Heading>
        <Text
          fontSize="17px"
          color="rgba(255,255,255,0.75)"
          fontWeight="500"
          letterSpacing="-0.01em"
          textShadow="0 1px 8px rgba(0,0,0,0.9)"
        >
          Never forget where you parked again.
        </Text>
      </VStack>

      {/* Features */}
      <VStack align="start" spacing={2.5}>
        {features.map((feat, i) => (
          <HStack key={i} spacing={3}>
            <Box
              w="20px"
              h="20px"
              borderRadius="full"
              bg="rgba(255,255,255,0.12)"
              border="1px solid rgba(255,255,255,0.25)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexShrink={0}
            >
              <Text fontSize="11px" fontWeight="800" color="white">
                {feat.icon}
              </Text>
            </Box>
            <Text
              fontSize="14px"
              color="rgba(255,255,255,0.85)"
              fontWeight="500"
              textShadow="0 1px 6px rgba(0,0,0,0.9)"
            >
              {feat.text}
            </Text>
          </HStack>
        ))}
      </VStack>

      {/* QR Code block */}
      <Box
        p={5}
        border="1.5px solid rgba(255,255,255,0.2)"
        borderRadius="20px"
        bg="rgba(0,0,0,0.3)"
        backdropFilter="blur(20px)"
        sx={{ WebkitBackdropFilter: 'blur(20px)' }}
      >
        <VStack align="start" spacing={3} w="100%">
          <Text
            fontSize="14px"
            fontWeight="800"
            letterSpacing="0.1em"
            textTransform="uppercase"
            color="rgba(255,255,255,0.7)"
          >
            Continue on your phone
          </Text>
          <HStack spacing={4} align="center" w="100%">
            <Box
              p={2.5}
              bg="white"
              borderRadius="14px"
              flexShrink={0}
            >
              <QRCodeSVG
                value={currentUrl}
                size={160}
                level="M"
                bgColor="#ffffff"
                fgColor="#000000"
                marginSize={0}
              />
            </Box>
            <VStack align="start" spacing={2} flex={1} minW={0}>
              <Text
                fontSize="13px"
                color="rgba(255,255,255,0.85)"
                lineHeight="1.5"
                fontWeight="600"
              >
                Scan to open on your phone
              </Text>
              <Text
                fontSize="11px"
                color="rgba(255,255,255,0.55)"
                lineHeight="1.5"
                fontWeight="400"
              >
                Note: data is saved per device. Records on your laptop won't appear on your phone.
              </Text>
            </VStack>
          </HStack>
        </VStack>
      </Box>

      {/* Footer hint */}
      <Text
        fontSize="11px"
        color="rgba(255,255,255,0.5)"
        fontWeight="500"
        textShadow="0 1px 6px rgba(0,0,0,0.9)"
      >
        Tip: add to your home screen for a native-app experience.
      </Text>
    </VStack>
  );
};

export default DesktopSidePanel;
